const ITEMS = ["Noleggio Multifunzione", "Assistenza Tecnica", "Toner & Consumabili", "PC & Periferiche", "Intervento Entro 24h", "Stampanti per Ufficio"];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-[#E5E2DC] py-6 overflow-hidden bg-[#F3F0EA]">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-2xl sm:text-3xl font-light text-[#181817]/70 px-8 whitespace-nowrap">{item}</span>
              <span className="font-mono text-xs text-[#C85A32]">—</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
